defaultVars